import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isPending: false,
  documents: [],
  professionalData: null,
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    setDocumentsAction: (state, action) => {
      state.documents = action.payload;
    },
    setIsPendingAction: (state, action) => {
      state.isPending = action.payload;
    },
    setProfessionalDataAction: (state, action) => {
      state.professionalData = action.payload;
    },
  },
});

export const {
  setDocumentsAction,
  setIsPendingAction,
  setProfessionalDataAction,
} = documentsSlice.actions;

export default documentsSlice.reducer;
